export enum BARCODE_DECODERS {
  'code-128' = 'code-128',
  'code-2of5' = 'code-2of5',
  'code-39' = 'code-39',
  'code-93' = 'code-93',
  'ean-13' = 'ean-13',
  'ean-8' = 'ean-8',
  'codabar' = 'codabar',
}
